module.exports = __webpack_public_path__ + "static/el_jefe_console-30c1625fe18a441d5806b3c13493a2ec.jpg";